const REFERRAL_STORAGE_KEY = 'flotte:referral-attribution';
const REFERRAL_ATTRIBUTION_TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 días

export const sanitizeReferralCode = value => {
  if (!value) return '';
  return String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 14);
};

export const buildReferralLink = (referralCode, origin) => {
  const normalizedCode = sanitizeReferralCode(referralCode);
  if (!normalizedCode) {
    return '';
  }
  const defaultOrigin =
    (typeof window !== 'undefined' && window.location?.origin) || 'https://flotte.mx';
  const baseOrigin = origin || defaultOrigin;
  const trimmedOrigin = baseOrigin.endsWith('/') ? baseOrigin.slice(0, -1) : baseOrigin;
  return `${trimmedOrigin}/register?ref=${encodeURIComponent(normalizedCode)}`;
};

export const persistReferralAttribution = ({ code, link, source = '' } = {}) => {
  if (typeof window === 'undefined') {
    return;
  }
  const normalizedCode = sanitizeReferralCode(code);
  if (!normalizedCode) {
    return;
  }
  const payload = {
    code: normalizedCode,
    link: link || buildReferralLink(normalizedCode),
    source,
    storedAt: Date.now(),
  };
  try {
    window.sessionStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn('No se pudo guardar el referido en sesión.', error);
  }
};

export const getStoredReferralAttribution = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.code) {
      return null;
    }
    if (
      parsed?.storedAt &&
      Date.now() - Number(parsed.storedAt) > REFERRAL_ATTRIBUTION_TTL_MS
    ) {
      window.sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const clearReferralAttribution = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // ignore storage errors
  }
};
